module.exports = __webpack_public_path__ + "04_long_grey.85493f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/04_long_grey.png
// module id = z7Pp
// module chunks = 0